import { render, staticRenderFns } from "./PaginationSelect.vue?vue&type=template&id=85f3a86a&scoped=true"
import script from "./PaginationSelect.vue?vue&type=script&lang=js"
export * from "./PaginationSelect.vue?vue&type=script&lang=js"
import style0 from "./PaginationSelect.vue?vue&type=style&index=0&id=85f3a86a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f3a86a",
  null
  
)

/* custom blocks */
import block0 from "./PaginationSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports